import React from "react";

import { ProposalContentProps } from "./content.model";
import { Button } from "@companion-core/shared/app/Components/Button";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { getModule } from "@companion-core/shared/app/Utils/config";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { useMountEffect } from "@companion-core/shared/app/Hooks/useMountEffect";
import {
  trackProofValuePage,
  trackProofValueClick,
  trackSkipProofValueClick,
} from "@companion-core/shared/app/tracking/blocks";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";

import "@companion-core/web/src/Assets/Styles/scss/universesLayout.scss";

export const Proposal = ({ t, universe, goBack, nextAction, skipAction }: ProposalContentProps) => {
  const onboarding = getModule("onboarding");
  const icons = onboarding?.icons;
  const isMobileScreen = useMediaQuery("(max-width: 768px)");

  useMountEffect(() => {
    trackProofValuePage({ universeSlug: universe.slug });
  });

  return (
    <section className="universes-layout__proposal-section">
      <div className="universes-layout__side-panel">
        <button
          type="button"
          className="universes-layout__side-panel-go-back-button"
          data-testid="universes-layout__button--go-back"
          onClick={goBack}>
          <FontIcon name="JP-Arrow-left-bold" size={isMobileScreen ? 24 : 34} />
          <span
            className={`universes-layout__side-panel-header-text ${isMobileScreen ? "body-text-7" : "title-7"}`}>
            {t("blocks.universes.tags.goBack")}
          </span>
        </button>
        <img
          className="universes-layout__side-panel-image"
          src={getCloudinaryOptimizedUrl(universe.medias?.[0]?.url ?? "", {
            contentType: "image",
            width: 720,
          })}
          alt={universe.name}
        />
      </div>
      <div className="universes-layout__proposal-content">
        <div className="universes-layout__proposal-content-body">
          <FontIcon name={icons?.[`${universe.slug}`] ?? "JP-Concierge-bell"} size={24} />
          <h1 className="universes-layout__proposal-content-title super-title-1">
            {universe.proposal_of_value_title}
          </h1>
          <p
            className="universes-layout__proposal-content-description body-text-6"
            // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
            dangerouslySetInnerHTML={{ __html: universe.proposal_of_value_description }}
          />
          {/* TODO: Add missing section here */}
        </div>
        <div className="universes-layout__proposal-content-footer">
          <Button
            onClick={() => {
              trackProofValueClick({ universeSlug: universe.slug });
              nextAction();
            }}
            label={t("blocks.universes.proposal.next")}
            testID="proposal-button--next"
            type={isMobileScreen ? "secondary" : "primary"}
            negative={isMobileScreen}
            size={isMobileScreen ? "full" : "large"}
          />
          <Button
            onClick={() => {
              trackSkipProofValueClick({ universeSlug: universe.slug });
              skipAction();
            }}
            label={t("blocks.universes.skip")}
            classNames={["universes-layout__proposal-content-footer-button--skip"]}
            testID="proposal-button--skip"
            type="ghost"
            size={isMobileScreen ? "full" : "large"}
          />
        </div>
      </div>
    </section>
  );
};
